// extracted by mini-css-extract-plugin
export default {"authLayout":"AuthLayout_authLayout__9nMge","main":"AuthLayout_main__UWu5t"};